export default "__VITE_ASSET__CzXMkWRM__"